import React from "react";
import { bool, func, object } from "prop-types";
import './styles.scss';

const TabsHeader = ({ active, handleClick, option }) => {

  return (
      <button
        key={option.label}
        type="button"
        onClick={handleClick}
        disabled={option.disabled}
        className={`tabs-panel__item ${active ? "-active" : ""} ${option.disabled ? "-disabled" : ""}`}
      >
        {option.label}
      </button>
  );
}

TabsHeader.propTypes = {
  option: object.isRequired,
  handleClick: func.isRequired,
  active: bool.isRequired,
};

export default TabsHeader;
